import React, { useReducer, useEffect } from "react";
import profile, { initialState, ProfileContext } from "./profile";

export default ({ children }) => {
  const [state, dispatch] = useReducer(profile, initialState);

  const value = {
    state,
    dispatch,
  };

  useEffect(() => {
    if (state) localStorage.setItem("PROFILE", JSON.stringify(state));
  }, [state]);

  return (
    <ProfileContext.Provider value={value}>{children}</ProfileContext.Provider>
  );
};
